/* eslint-disable react/prop-types */
import { Container, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------
const RootStyle = styled(Container)((style) => ({
  marginTop: 20,
  marginBottom: 20,
  padding: 10,
  backgroundColor: style.theme.palette.background.neutral,
  borderRadius: 5,
}));

export default function Claimnation() {
  return (
    <RootStyle maxWidth={"xl"}>
      <Stack spacing={2}>
        <Typography variant='subtitle1' color={"primary"}>LƯU Ý:</Typography>
        <Typography variant='body'>✔️ Phần mềm thi thử mô phỏng 120 tình huống giao thông online của chúng tôi được phát triển dựa trên phần mềm offline do Tổng Cục Đường Bộ Việt Nam ban hành trước đó. Nhằm giúp học viên không có máy tính có thể học và ôn tập trực tiếp trên điện thoại, máy tính bảng hoặc máy tính có cấu hình yếu không đủ điều kiện tải phần mềm.</Typography>
        <Typography variant='body'>✔️ Đây là tổng hợp các tình huống với mục đích kiểm tra nhận thức, phản xạ trước các mối nguy hiểm khi tham gia giao thông. Đã có rất nhiều nước phát triển trên thế giới như Anh, Hà Lan, Úc áp dụng phần mềm này vào sát hạch cấp GPLX và mang lại hiệu quả rõ rệt trong việc giảm thiểu số vụ tai nạn giao thông.</Typography>
        <Typography variant='body'>✔️ Có thể học thuộc và nắm rõ 120 tình huống mô phỏng này đồng nghĩa bạn sẽ vượt qua phần thi mô phỏng 1 cách dễ dàng, không cần lo lắng. Ngoài ra, bạn còn có thêm các kỹ năng phản xạ thực tế khi tham gia giao thông sau này.</Typography>
      </Stack>
    </RootStyle>
  );
}

